import { observer } from "mobx-react-lite";
import React from "react";
import stateAnalyticApp from "../../../state/stateAnalyticApp";
import AnalyticChartData from "../../../api/AnalyticChartData";
import { CcV4Toggle } from "../../UI/CcV4Toggle";
import { BtnPrimaryv4 } from "../../UI/button/BtnPrimaryv4";
import AnalyticIncidentData from "../../../api/AnalyticIncidentData";
import iconBtnSearch from "../../../img/icons/analytics/search_mobile.png";

export const AnalyticsFilterBar = observer(({ page, onAfterFetch }) => {
  const showGrapch = async () => {
    if (page === "analitic") {
      const resLabel = await AnalyticChartData.getLabelData();
      if (resLabel) {
        onAfterFetch?.();
      }
    }
    if (page === "incident") {
      const resIncident = await AnalyticIncidentData.fetchList();
      if (resIncident) {
        onAfterFetch?.();
      }
    }
  };

  return (
    <div className="filter_container">
      От
      <input
        className="input_date"
        type="date"
        value={stateAnalyticApp.from_date ?? ""}
        onChange={(e) => {
          stateAnalyticApp.setParameter("from_date", e.target.value);
        }}
      />
      До
      <input
        className="input_date"
        type="date"
        value={stateAnalyticApp.to_date ?? ""}
        onChange={(e) => {
          stateAnalyticApp.setParameter("to_date", e.target.value);
        }}
      />
      {!stateAnalyticApp.mobile ? (
        <BtnPrimaryv4 text="Показать" onClick={showGrapch} />
      ) : (
        <img
          className="btn_search_mobile"
          alt="поиск"
          src={iconBtnSearch}
          onClick={showGrapch}
        />
      )}
      {page === "analitic" ? (
        <label className="btn_check_container analytics-gap-toggle">
          {!stateAnalyticApp.mobile ? "Игнорировать зазор (GAP)" : "gap"}
          <CcV4Toggle
            active={stateAnalyticApp.gap_ignore}
            onClick={() =>
              stateAnalyticApp.setParameter("gap_ignore", !stateAnalyticApp.gap_ignore)
            }
          />
        </label>
      ) : (
        <></>
      )}
    </div>
  );
});
